import React, { Component } from 'react'
import {
 Dimensions, ScrollView, View,
} from 'react-native'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { colors } from '../../styles'
import SectionPanel from '../subcomponents/SectionPanel'
import { gotoSubPage } from '../../actions/helpers'

class FAQHomePage extends Component {
    render() {
        const { t } = this.props
        const { height: heightOfDeviceScreen } = Dimensions.get('window')
        return (
          <View style={{ flex: 1, backgroundColor: colors.raven_grey10 }}>
            <ScrollView
              contentContainerStyle={{ minHeight: this.height || heightOfDeviceScreen }}
              style={{
                        flexGrow: 1,
                        marginTop: 16,
                    }}
              accessibilityLabel={t('access:faqSectionList')}
              testID="scrollview-FAQHomePage"
              refs={this.scrollViewRef}
            >
              <SectionPanel
                testID="monitoring-SystemPanel"
                t={t}
                descriptionKey="faq:learnMoreMonitoringSys"
                titleKey="faq:yourMonitoringSystem"
                onPress={() => gotoSubPage('FAQMonitoringSystemPage', 'faqMonitoringSystem', false)}
              />

              <SectionPanel
                testID="device-SystemPanel"
                t={t}
                descriptionKey="faq:learnMoreCardiacDevice"
                titleKey="faq:yourImplantedDevice"
                onPress={() => gotoSubPage('FAQDeviceSystemPage', 'faqDeviceSystem', false)}
              />

              <SectionPanel
                testID="bsc-SystemPanel"
                t={t}
                descriptionKey="faq:learnMoreManufacturer"
                titleKey="faq:aboutBSCI"
                onPress={() => gotoSubPage('FAQBSCPage', 'faqDeviceSystem', false)}
              />
            </ScrollView>
          </View>
        )
    }
}

FAQHomePage.propTypes = {
  t: PropTypes.func.isRequired,
}

export const FAQHomePageComponent = FAQHomePage

export default withTranslation(['faq'])(FAQHomePage)
